import React, { useEffect, useState, useRef } from 'react';
import './qr.css';
import QRCodeStyling from "qr-code-styling";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import { getDataForQRSagaAction, setQRSettingsSagaAction } from "../../redux/sagaActions";
import { site } from "../../config";
import { ChromePicker } from 'react-color';
import { photoFileAction, qrDataAction } from "../../redux/rootReducer";
import image from "../../assets/i/image.svg";

const QR = () => {
    const dispatch = useDispatch();
    const qr_data = useSelector(state => state.qr_data);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const photo_file = useSelector(state => state.photo_file);

    const ref = useRef(null);

    const [openColor, setOpenColor] = useState(false);
    const [openImg, setOpenImg] = useState(false);

    const [options, setOptions] = useState({
        width: 280,
        height: 280,
        type: 'svg',
        data: 'https://alga.by',
        image: false,
        margin: 0,
        qrOptions: {
            typeNumber: 0,
            mode: 'Byte',
            errorCorrectionLevel: 'Q'
        },
        imageOptions: {
            hideBackgroundDots: true,
            imageSize: .5,
            margin: 3
        },
        dotsOptions: {
            color: '#111111',
            type: 'rounded'
        },
        backgroundOptions: {
            color: '#fff'
        },
        cornersSquareOptions: {
            color: '#111111',
            type: 'extra-rounded',
        },
        cornersDotOptions: {
            color: '#111111',
            type: 'dot',
        }
    });
    const [qrCode] = useState(new QRCodeStyling(options));

    const readFile = input => {
        // Ссылка на читаемый файл
        let file = input.target.files[0];

        if (!file) return false;

        // Создаём ссылку на FileReader
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            dispatch(photoFileAction({ file, image: reader.result }));
        };
    };

    useEffect(() => {
        // Если нет текущего заведения, не запрашиваем данные для qr-кода
        if (!currentEstablishment) return;
        dispatch(getDataForQRSagaAction());
    }, [currentEstablishment]);

    useEffect(() => {
        if (ref.current) {
            qrCode.append(ref.current);
        }
    }, [qrCode, ref]);

    useEffect(() => {
        if (!qrCode) return;
        qrCode.update({
            ...options,
            data: qr_data.link,
            image: qr_data.logo
                ? site + qr_data.logo
                : photo_file?.image
                    ? photo_file.image
                    : false,
            dotsOptions: {
                ...options.dotsOptions,
                color: qr_data.color
            },
            cornersSquareOptions: {
                ...options.cornersSquareOptions,
                color: qr_data.color
            },
            cornersDotOptions: {
                ...options.cornersDotOptions,
                color: qr_data.color
            }
        });
    }, [qrCode, options, qr_data]);

    const downloadQR = () => {
        qrCode.download({
            name: 'qr-код',
            extension: 'svg'
        });
    };

    return (
        <>
            <Header />
            <div className="page">
                <div className="qr">
                    <div className="table__header">
                        <div className="table__caption">QR-код вашего заведения</div>
                    </div>
                    <div className="qr__hint">Скачайте этот qr-код и разместите его на видных местах заведения.<br/> С его помощью ваши посетители смогут самостоятельно списать занятие со<br/> своего абонемента или скачать приложение.</div>
                    <div className="qr__wrapper">
                        <div className="qr__img">
                            <div ref={ ref }/>
                            <div onClick={ () => downloadQR(`QR-код`) } className={ 'qr__download' }>Скачать QR код</div>
                        </div>
                        <div className="qr__settings">
                            <div className="qr__color">
                                <div className="qr__open-setting"
                                     onClick={ () => setOpenColor(!openColor) }
                                >{ openColor ? 'Скрыть палитру' : 'Выбрать цвет QR-кода' }</div>
                                {
                                    openColor
                                        ?
                                        <ChromePicker
                                            color={ qr_data.color }
                                            onChangeComplete={ color => dispatch(qrDataAction({
                                                ...qr_data,
                                                color: color.hex
                                            })) }
                                            className="qr__color-picker"
                                        />
                                        : false
                                }
                            </div>
                            <div className="qr__logo-wrapper">
                                <div className="qr__open-setting"
                                    onClick={ () => setOpenImg(!openImg) }
                                >{ openImg ? 'Скрыть выбор лого' : 'Выбрать лого для QR-кода' }</div>
                                {
                                    openImg
                                    ?
                                        <div className="qr__img-wrapper">
                                            <label className="form__image-wrapper">
                                                <input type="file" className="form__file" onChange={ file => readFile(file) } />
                                                <div className="form__image"
                                                     style={
                                                         photo_file?.image
                                                             ? { backgroundImage: `url(${ photo_file.image })`}
                                                             : qr_data.logo
                                                             ? { backgroundImage: `url(${ site + qr_data.logo })` }
                                                             : { backgroundImage: `url(${ image })`, backgroundSize: `${ 28 }px`, opacity: .48 }
                                                     }
                                                />
                                            </label>
                                            {
                                                (photo_file?.image) || qr_data.logo
                                                    ? <div className="form__image-remove"
                                                           onClick={ () => {
                                                               dispatch(qrDataAction({
                                                                   ...qr_data,
                                                                   logo: ''
                                                               }));
                                                               dispatch(photoFileAction(null));
                                                           } } >Удалить</div>
                                                    : false
                                            }
                                        </div>
                                    : false
                                }
                            </div>
                            <div className="button"
                                onClick={ () => {
                                    dispatch(setQRSettingsSagaAction({
                                        color: qr_data.color,
                                        logo: photo_file || qr_data.logo
                                    }));
                                } }
                            >Сохранить настройки QR-кода</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QR;